import React from 'react';
import { PropTypes as T } from 'prop-types';
import { FormGroup, Label, FormText } from 'reactstrap';

import Base from 'app/components/model_forms/base';
import BoundInput from 'app/components/forms/input/bound_input';
import FormRow from 'app/components/bootstrap/form_row';

import CustomsItem from 'app/models/customs_item';

export default class CustomsItemForm extends Base {
  static propTypes = {
    model: T.instanceOf(CustomsItem).isRequired,
  }

  render() {
    const { model } = this.props;

    return (
      <div>
        <FormGroup>
          <Label>Description of item</Label>
          <BoundInput bsSize="sm" model={model} property="description" />
        </FormGroup>

        <FormRow>
          <FormGroup className="col-md-4">
            <Label>Quantity</Label>
            <BoundInput bsSize="sm" model={model} property="quantity" />
          </FormGroup>

          <FormGroup className="col-md-4">
            <Label>Total Value</Label>
            <BoundInput bsSize="sm" model={model} property="value" />
            <FormText className="form-text-sm">(unit value * quantity)</FormText>
          </FormGroup>

          <FormGroup className="col-md-4">
            <Label>Currency</Label>
            <BoundInput bsSize="sm" model={model} property="currency" />
            <FormText className="form-text-sm">3-letter code, e.g. USD</FormText>
          </FormGroup>
        </FormRow>

        <FormGroup>
          <Label>
            Total Weight (oz)
          </Label>
          <BoundInput bsSize="sm" model={model} property="weight" />
          <FormText className="form-text-sm">(unit value * quantity)</FormText>
        </FormGroup>

        <FormGroup>
          <Label>
            Harmonized Tariff Schedule
          </Label>

          <BoundInput bsSize="sm" model={model} property="hs_tariff_number" />
          <FormText className="form-text-sm">e.g. {'"6109.10.0012" for Men\'s T-shirts'}</FormText>
        </FormGroup>

        <FormGroup>
          <Label>
            Product Identifier
          </Label>
          <BoundInput bsSize="sm" model={model} property="code" />
          <FormText className="form-text-sm">SKU/UPC or other identifier</FormText>
        </FormGroup>

        <FormGroup>
          <Label>Origin Country</Label>
          <BoundInput bsSize="sm" model={model} property="origin_country" />
          <FormText className="form-text-sm">(2-letter code)</FormText>
        </FormGroup>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./app/components/model_forms/customs_item/index.jsx